module.exports = __webpack_public_path__ + "static/media/dreamerhug-5.02c79dac.jpg";